<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div style="display: flex; justify-content: center; flex-direction: column">
      <div
        #affirmationContainer
        class="light-shade box rounded-corners"
        style="width: 100%; max-width: 800px; margin-top: 10px"
        [ngStyle]="boxHeight">
        <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
          <div>{{ title }}</div>
        </div>
        <div style="overflow-y: scroll; margin: 10px" [ngStyle]="textHeight">
          <div [innerHtml]="viewText"></div>
        </div>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>
